// Web-specific lightweight PostsServices (sin SQLite)
// Se carga gracias a la resolución de plataforma de RN (posts.database.web.js)

// Nota: Este stub se apoya en el cache del servicio web (fetchWallWeb)
let webCacheApi = {}
try {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  webCacheApi = require('../src/services/web/postsWebService')
} catch {}

const LS_KEY = 'web_posts_memory_v1'
const memoryState = {
  posts: [],
  reactions: [],
  viewed: new Set(),
  user: null,
}

const persist = () => {
  try {
    const payload = {
      posts: memoryState.posts,
      reactions: memoryState.reactions,
      viewed: Array.from(memoryState.viewed),
      user: memoryState.user,
      ts: Date.now(),
    }
    localStorage.setItem(LS_KEY, JSON.stringify(payload))
  } catch {}
}

const loadPersisted = () => {
  try {
    const raw = localStorage.getItem(LS_KEY)
    if (!raw) return
    const data = JSON.parse(raw)
    if (Array.isArray(data.posts)) memoryState.posts = data.posts
    if (Array.isArray(data.reactions)) memoryState.reactions = data.reactions
    if (Array.isArray(data.viewed)) memoryState.viewed = new Set(data.viewed)
    memoryState.user = data.user || null
  } catch {}
}
loadPersisted()

export class postsServices {
  constructor() {}

  hydrateFromCache() {
    const cachedPosts = webCacheApi.getCachedPosts?.() || []
    if (cachedPosts.length) { memoryState.posts = cachedPosts; persist() }
  }

  async getAllLabels() {
    this.hydrateFromCache()
    // Derivar labels de posts (similar a lógica nativa)
    const allLabels = memoryState.posts.flatMap(p => p.labels || [])
    const unique = Array.from(new Map(allLabels.map(l => [l._id + ':' + l.index, l])).values())
    return unique.sort((a,b) => a.index - b.index)
  }

  async getAllPosts(page = 0, size = -1) {
    this.hydrateFromCache()
    if (size === -1) return memoryState.posts
    const start = page * size
    return memoryState.posts.slice(start, start + size)
  }

  async getAllReactions() { return memoryState.reactions }
  async addReaction(reaction) { if (!memoryState.reactions.find(r=>r._id===reaction._id)) { memoryState.reactions.push(reaction); persist() } }
  async addAllPosts(posts) { memoryState.posts = posts; persist() }
  async deleteAllTablesPosts() { memoryState.posts = []; memoryState.reactions = []; memoryState.viewed.clear(); persist() }
  async getFavouritePosts() { return memoryState.posts.filter(p => p.status_favourite === 1) }
  async getUser() { return memoryState.user }
  async update_view_local_posts(post_id, views) {
    const p = memoryState.posts.find(p=>p._id===post_id); if (p) { p.views = views; persist() } return true
  }
  async get_post_viewed() { return Array.from(memoryState.viewed).map(id => ({ _id: id })) }
  async delete_posts_viewed_from_local(id) { memoryState.viewed.delete(id); persist() }
  async addViewedPost(id) { if (id) { memoryState.viewed.add(id); persist() } }
  async getLocationUser() { return null }
  async get_all_surveys() { return [] }
  async delete_survey_by_id() { return true }
  async updateUserLocation(lat, lng, last_update) {
    // Stub web: podríamos opcionalmente almacenar en memoryState.user
    try {
      if (!memoryState.user) memoryState.user = {}
      memoryState.user.last_location = { lat, lng, last_update }
      persist()
    } catch {}
    return true
  }
}

export const PostsServices = new postsServices()
